import * as React from 'react';
import { Button, Typography } from 'antd';
const { Text, Paragraph } = Typography;

export interface WidgetInputUploadSignedTextProps {
  previewOnly?: boolean;
}

export function WidgetInputUploadSignedText(
  props: WidgetInputUploadSignedTextProps
) {
  return props.previewOnly ? (
    <Paragraph>
      Scarica il modulo per verificare la correttezza dei dati inseriti, prima
      di procedere con l'inoltro dell'istanza.
    </Paragraph>
  ) : (
    <Paragraph>
      Scarica il modulo per verificare la correttezza dei dati inseriti.
    </Paragraph>
  );
}
